import { DropdownCheckbox, Icon, Typography } from '@/components/common';
import { ComboBoxOption } from '@/interfaces';

interface Props {
	label: string;
	icon: string;
	filters: ComboBoxOption[];
	handleSelectFilters: (values: string[]) => void;
}

export const TableFilterIcon: React.FC<Props> = ({
	label,
	icon,
	filters,
	handleSelectFilters,
}) => {
	return (
		<div className="flex items-center gap-2">
			<Typography type="regular-12" className="opacity-60">
				{label}
			</Typography>
			<DropdownCheckbox
				side="right"
				sideOffset={-15}
				align={'start'}
				options={filters}
				alignOffset={20}
				onSelect={handleSelectFilters}
				buttonContent={<Icon src={icon} className="!w-4 !h-4" />}
			/>
		</div>
	);
};
